var $ed6bec4d46a5be1b$exports = {};
$ed6bec4d46a5be1b$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Datos`,
            other: `Dat\u{173}`
        })} pasirinkimas negalimas.`
};


export {$ed6bec4d46a5be1b$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
